import { useOptimizelyDecisionsContext } from 'src/context/optimizely-decisions-context'
import { OPTIMIZELY_FLAGS_ENUM } from '../../../constants'
import getConfig from 'next/config'

export function useAcq1173DisableImpressionDataLayerPush(): string | null {
  const optiContext = useOptimizelyDecisionsContext()
  const { publicRuntimeConfig } = getConfig()
  const { APP_ENV } = publicRuntimeConfig
  const optimizelyPlacesData = optiContext?.getExperimentVariables(
    OPTIMIZELY_FLAGS_ENUM.AGE_MFE_ACTIVATE_PLACES_API,
  )?.[publicRuntimeConfig[APP_ENV]?.features?.placesApiOptimizelyVariableKey]
  return (
    optimizelyPlacesData?.['disableImpressionDataLayerPushForVariationKey'] ||
    null
  )
}
